import { Spacing } from '../../../enums/spacing'

export const MODAL_HORIZONTAL_PADDING = Spacing.S32
